import React from "react";

export const AdminHeader = ({ title, subtitle, children }) => (
  <div className="bg-white border-b border-f2b-filet px-8 py-6 flex items-center justify-between sticky top-0 z-20">
    <div>
      <h1 className="font-display font-bold text-f2b-black text-2xl">{title}</h1>
      {subtitle && <p className="text-f2b-gray text-sm mt-1">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-3">{children}</div>
  </div>
);

export const AdminBody = ({ children }) => <div className="p-8">{children}</div>;

export default AdminHeader;
